export const DASHBOARD = 'dashboard'
export const LOGIN = '/'
export const SIGN_UP = 'sign-up'
export const PROFILE = 'p/:username'
export const NOT_FOUND = 'not-found'
export const UNDER_CONSTRUCTION='/under-construction'